import {
  InternshipCreateFormModel,
  InternshipCreateRequestPayload,
  InternshipEditFormModel,
  InternshipUpdateRequestPayload,
} from "./types";

export function getCreateRequestPayload(model: InternshipCreateFormModel): InternshipCreateRequestPayload {
  const { useHqAddress, address, city, responsiblePerson, startDate, endDate, ...rest } = model;
  const addressModel = useHqAddress ? { useHqAddress, city: "", address: "" } : { useHqAddress, address, city };
  const names = responsiblePerson.fullName.trim().split(" ");
  const surname = names.splice(-1).join(" ");
  const firstName = names.join(" ");
  const person = {
    firstName,
    surname,
    jobTitle: responsiblePerson.jobTitle,
    email: responsiblePerson.email,
    phoneNumber: responsiblePerson.phoneNumber,
  };

  return { ...rest, ...addressModel, responsiblePerson: person, startDate, endDate };
}

export function getUpdateRequestPayload(model: InternshipEditFormModel): InternshipUpdateRequestPayload {
  const { useHqAddress, address, city, remote, startDate, endDate, industryIds } = model;
  const addressModel = useHqAddress ? { useHqAddress, city: "", address: "" } : { useHqAddress, address, city };

  return {
    title: model.title,
    description: model.description,
    startDate,
    endDate,
    participantsCapacity: model.participantsCapacity,
    remote,
    industryIds,
    ...addressModel,
  };
}
